"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4349],{

/***/ 4349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Hero; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(6677);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Link-479ac100.mjs
var Link_479ac100 = __webpack_require__(965);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Button-c598cb52.mjs
var Button_c598cb52 = __webpack_require__(7977);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Video-232035c2.mjs
var Video_232035c2 = __webpack_require__(970);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Image-d6406817.mjs
var Image_d6406817 = __webpack_require__(5905);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/Hero.js







const b = "mouse", v = "mouse__icon", y = "mouse__wheel", T = "wheelUpDown", p = {
  mouse: b,
  mouseIcon: v,
  mouseWheel: y,
  wheelUpDown: T
};
function f() {
  return /* @__PURE__ */ react.createElement("div", { className: p.mouse }, /* @__PURE__ */ react.createElement("div", { className: p.mouseIcon }, /* @__PURE__ */ react.createElement("span", { className: p.mouseWheel })));
}
const C = "hero", S = "hero__block-auto", k = "hero__wrapper", W = "hero__overlay", x = "hero__content", L = "desktop", P = "hero__buttons", H = "hero__title", O = "hero__title--lead-text", A = "hero--align-bottom", R = "hero__scroll-wheel", U = "hero--content-below-image", V = "hero__image-band", M = "hero__image-band-content", $ = "hero__below-image-headline", j = "hero__below-section", q = "hero__below-lead-text", z = "hero__below-buttons", F = "button", o = {
  hero: C,
  heroBlockAuto: S,
  heroWrapper: k,
  heroOverlay: W,
  heroContent: x,
  desktop: L,
  heroButtons: P,
  heroTitle: H,
  heroTitleLeadText: O,
  heroAlignBottom: A,
  heroScrollWheel: R,
  heroContentBelowImage: U,
  heroImageBand: V,
  heroImageBandContent: M,
  heroBelowImageHeadline: $,
  heroBelowSection: j,
  heroBelowLeadText: q,
  heroBelowButtons: z,
  button: F
};
function ee({
  heading: n,
  leadText: t,
  imageAltText: l,
  videoAltText: a,
  buttons: r,
  video: s,
  assetType: c,
  imageData: h,
  viewport: i,
  credits: d,
  variant: u = "default"
}) {
  return u === "contentBelowImage" ? /* @__PURE__ */ react.createElement(
    G,
    {
      heading: n,
      leadText: t,
      imageAltText: l,
      videoAltText: a,
      buttons: r,
      video: s,
      assetType: c,
      imageData: h,
      viewport: i,
      credits: d
    }
  ) : /* @__PURE__ */ react.createElement(
    Block_9b78bd10.B,
    {
      topPadding: Block_9b78bd10.B.Padding.NONE,
      bottomPadding: Block_9b78bd10.B.Padding.NONE,
      "data-testid": "hero-block"
    },
    /* @__PURE__ */ react.createElement(
      "div",
      {
        className: o.hero,
        "data-testid": "hero",
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      /* @__PURE__ */ react.createElement(
        _,
        {
          assetType: c,
          imageData: h,
          imageAltText: l,
          video: s,
          videoAltText: a,
          viewport: i,
          credits: d
        }
      ),
      /* @__PURE__ */ react.createElement("div", { className: o.heroOverlay }),
      /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { className: o.heroBlockAuto }, /* @__PURE__ */ react.createElement("div", { className: o.heroWrapper }, /* @__PURE__ */ react.createElement("div", { className: o.heroContent }, /* @__PURE__ */ react.createElement(
        "h1",
        {
          className: (0,app_a75c1d35.c)(app_a75c1d35.t.heroText, o.heroTitle),
          itemProp: "name"
        },
        n
      ), t && /* @__PURE__ */ react.createElement(
        "p",
        {
          className: (0,app_a75c1d35.c)(
            app_a75c1d35.t.textsLeadText,
            o.heroTitle,
            o.heroTitleLeadText
          ),
          itemProp: "description"
        },
        t
      ), /* @__PURE__ */ react.createElement(
        "span",
        {
          className: o.heroButtons,
          "data-testid": "hero-button-container",
          itemProp: "description"
        },
        r
      )))),
      /* @__PURE__ */ react.createElement(Block_9b78bd10.B.Content, { className: o.heroAlignBottom }, /* @__PURE__ */ react.createElement("div", { className: o.heroScrollWheel }, /* @__PURE__ */ react.createElement(f, null)))
    )
  );
}
function G({
  heading: n,
  leadText: t,
  imageAltText: l,
  videoAltText: a,
  buttons: r,
  video: s,
  assetType: c,
  imageData: h,
  viewport: i,
  credits: d
}) {
  const u = !!t || !!r?.length;
  return /* @__PURE__ */ react.createElement(
    "div",
    {
      className: o.heroContentBelowImage,
      "data-testid": "hero-block",
      itemScope: !0,
      itemType: "https://schema.org/Thing"
    },
    /* @__PURE__ */ react.createElement("div", { className: o.heroImageBand, "data-testid": "hero" }, /* @__PURE__ */ react.createElement(
      _,
      {
        assetType: c,
        imageData: h,
        imageAltText: l,
        video: s,
        videoAltText: a,
        viewport: i,
        credits: d
      }
    ), /* @__PURE__ */ react.createElement("div", { className: o.heroOverlay }), /* @__PURE__ */ react.createElement("div", { className: o.heroImageBandContent }, /* @__PURE__ */ react.createElement(
      "h1",
      {
        className: (0,app_a75c1d35.c)(
          app_a75c1d35.t.heroText,
          o.heroTitle,
          o.heroBelowImageHeadline
        ),
        itemProp: "name"
      },
      n
    ))),
    u && /* @__PURE__ */ react.createElement("section", { className: o.heroBelowSection }, t && /* @__PURE__ */ react.createElement(
      "p",
      {
        className: o.heroBelowLeadText,
        itemProp: "description"
      },
      t
    ), r && r.length > 0 && /* @__PURE__ */ react.createElement(
      "div",
      {
        className: o.heroBelowButtons,
        "data-testid": "hero-button-container"
      },
      r
    ))
  );
}
function _({
  assetType: n,
  imageData: t,
  imageAltText: l,
  video: a,
  videoAltText: r,
  viewport: s,
  credits: c
}) {
  return n === "image" && t ? /* @__PURE__ */ react.createElement(
    Image_d6406817.I,
    {
      credits: c,
      src: t.imageSrc,
      width: t.width,
      height: t.height,
      altText: l ?? "",
      imageLoader: t.imageLoader,
      styling: Image_d6406817.a.HERO
    }
  ) : a && n === "video" ? /* @__PURE__ */ react.createElement(
    Video_232035c2.V,
    {
      title: r ?? "",
      autoplay: !0,
      videoType: "asset",
      video: a,
      styling: Video_232035c2.a.HERO,
      viewport: s
    }
  ) : null;
}

//# sourceMappingURL=Hero.js.map

// EXTERNAL MODULE: ./src/contexts/ViewportContext.tsx
var ViewportContext = __webpack_require__(9366);
// EXTERNAL MODULE: ./src/contexts/EmployerSiteContext.tsx
var EmployerSiteContext = __webpack_require__(981);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/magnolia/components/Hero/Hero.tsx










function Hero(param) {
    var heading = param.heading, leadText = param.leadText, asset = param.asset, buttons = param.buttons, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant;
    var ref;
    var router = (0,next_router.useRouter)();
    var viewport = (0,ViewportContext/* default */.Z)().viewport;
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    var isContentBelowImage = variant === "contentBelowImage";
    var buttonObjects = (0,magnolia/* jcrMultiFieldToArray */.FE)(buttons);
    var buttonLinks = buttonObjects.map(function(button, index) {
        var link = (0,magnolia/* formatPageLink */.Jd)(button.link, router === null || router === void 0 ? void 0 : router.isPreview, button.anchorTag);
        var HeroButton = resolveHeroButton(isContentBelowImage, isEmployerSite, button.type, index);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_479ac100.L, {
            className: Button_c598cb52.B.DefaultFocusStyleInLink,
            href: link,
            disableLinkTextStyle: true,
            itemProp: "url",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroButton, {
                asDiv: true,
                text: button.text
            })
        }, button.text);
    });
    if (asset.field === "video") {
        var ref1, ref2, ref3, ref4, ref5, ref6;
        var videoXS = asset.videoXS, videoSM = asset.videoSM, videoLG = asset.videoLG, videoAltText = asset.videoAltText;
        var videoSrc = [
            {
                src: (0,magnolia/* getAssetPath */.K3)(videoXS, router.isPreview),
                mimeType: (ref1 = videoXS.metadata) === null || ref1 === void 0 ? void 0 : ref1.mimeType,
                device: [
                    "xs"
                ],
                credits: videoXS === null || videoXS === void 0 ? void 0 : (ref2 = videoXS.metadata) === null || ref2 === void 0 ? void 0 : ref2.rights
            },
            {
                src: (0,magnolia/* getAssetPath */.K3)(videoSM, router.isPreview),
                mimeType: (ref3 = videoSM.metadata) === null || ref3 === void 0 ? void 0 : ref3.mimeType,
                device: [
                    "sm",
                    "md"
                ],
                credits: videoSM === null || videoSM === void 0 ? void 0 : (ref4 = videoSM.metadata) === null || ref4 === void 0 ? void 0 : ref4.rights
            },
            {
                src: (0,magnolia/* getAssetPath */.K3)(videoLG, router.isPreview),
                mimeType: (ref5 = videoLG.metadata) === null || ref5 === void 0 ? void 0 : ref5.mimeType,
                device: [
                    "lg",
                    "xl"
                ],
                credits: videoLG === null || videoLG === void 0 ? void 0 : (ref6 = videoLG.metadata) === null || ref6 === void 0 ? void 0 : ref6.rights
            }, 
        ];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ee, {
                assetType: asset.field,
                heading: heading,
                leadText: leadText,
                video: videoSrc,
                viewport: viewport,
                videoAltText: videoAltText,
                buttons: buttonLinks,
                variant: variant
            })
        });
    }
    var image = asset.image, imageAltText = asset.imageAltText;
    var imageData = imageDataHandler(image);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ee, {
            imageData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
                imageSrc: imageData.src
            }),
            assetType: asset.field,
            heading: heading,
            leadText: leadText,
            imageAltText: imageAltText,
            buttons: buttonLinks,
            credits: image === null || image === void 0 ? void 0 : (ref = image.metadata) === null || ref === void 0 ? void 0 : ref.rights,
            variant: variant
        })
    });
}
function resolveHeroButton(isContentBelowImage, isEmployerSite, type, index) {
    if (!isContentBelowImage) {
        return isEmployerSite ? Button_c598cb52.B.HeroEmployer : Button_c598cb52.B.HeroTalents;
    }
    var isSecondary = type === "secondary" || !type && index > 0;
    return isSecondary ? Button_c598cb52.B.Secondary : Button_c598cb52.B.Primary;
}

;// CONCATENATED MODULE: ./src/magnolia/components/Hero/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 970:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ h; },
/* harmony export */   "a": function() { return /* binding */ C; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3406);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4877);



const A = "video", f = "video__hero", g = "video__article", k = "desktop", P = "video__caption", d = {
  video: A,
  videoHero: f,
  videoArticle: g,
  desktop: k,
  videoCaption: P
};
var C = /* @__PURE__ */ ((t) => (t.ARTICLE = "videoArticle", t.HERO = "videoHero", t))(C || {});
function h({
  title: t,
  caption: s,
  styling: i,
  autoplay: l,
  embed: o,
  image: u = "",
  videoType: c,
  video: r,
  viewport: m
}) {
  const E = Array.isArray(r) ? r.find((y) => m && y.device?.includes(m)) : r, a = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(d.video, i && d[i]), p = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, c === "icareusIframe" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: a,
      dangerouslySetInnerHTML: { __html: o }
    }
  ), c === "embed" && (o?.includes("iframe") ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "div",
    {
      className: a,
      dangerouslySetInnerHTML: { __html: o }
    }
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-embed",
      itemProp: "video",
      title: t,
      className: a,
      src: o,
      playsInline: !0,
      controls: !0
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("track", { kind: "captions" })
  )), c === "asset" && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, l ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-asset",
      itemProp: "video",
      title: t,
      className: a,
      src: E?.src,
      autoPlay: l,
      loop: !0,
      muted: !0,
      playsInline: !0
    }
  ) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    "video",
    {
      "data-testid": "videoplayer-asset-control",
      itemProp: "video",
      title: t,
      className: a,
      controls: !0,
      poster: u,
      playsInline: !0
    },
    !Array.isArray(r) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", { src: r.src, type: r.mimeType }),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("track", { kind: "captions" })
  )));
  return i === "videoArticle" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B,
    {
      topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.SMALL,
      bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Padding.LARGE,
      "data-testid": "article-video"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_2__.B.Content, { "data-testid": "article-video-content" }, p, s && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", { className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_1__.t.textsCaption, d.videoCaption) }, s))
  )) : p;
}

//# sourceMappingURL=Video-232035c2.mjs.map


/***/ })

}]);